<template>
    <div style="position: relative;">
        <el-row style="padding: 10px; position: fixed; top: 0; width: 100%; background-color: white;">
            <el-col :span="8" style="padding-top: 1%;">
                <img src="../assets/fanhui.png" style="width: 20px; height: 20px;" @click="close()">
            </el-col>

        </el-row>
        <!-- {{ ProjectInfo }} -->
        <div style="padding: 0 20px; margin-top: 50px;">
            <div style="display: flex; align-items: center;">
                <div style="width: 70px; height: 70px; padding: 20px;">
                    <!-- {{ ProjectInfo }} -->
                    <img :src="`/api/file/download/${ProjectInfo.icon}`" alt="" style="width: 100%;">
                </div>
                <div style="flex: 1;">
                    <div style="display: flex; align-items: center;">
                        <div style="font-size: 22px; font-weight: 800; color: #3E4F7A;">{{ ProjectInfo.name }}
                        </div>
                        <el-tag size="small" effect="dark" style="border-radius: 15px; margin-left: 6px;">
                            {{ ProjectInfo.shape }}
                        </el-tag>
                    </div>
                    <div style="font-size: 16px; color: grey; margin-top: 6px;">{{ ProjectInfo.desc }}
                    </div>
                </div>
            </div>
            <!-- 核心標籤 -->
            <div style="margin-bottom: 25px; display: flex; align-items: center; margin-top: 12px;">
                <el-tag v-for="(tag, index) in JSON.parse(ProjectInfo.tags)" :key="index" size="small"
                    style="margin-right: 12px; border-radius: 15px;">
                    {{ tag }}
                </el-tag>
            </div>
        </div>

        <div style="padding: 0 20px;">
            <div style="background: #F9FAFC; border-radius: 12px; padding: 18px; margin-bottom: 20px;">
                <div style="color: #3E4F7A; font-weight: 600; margin-bottom: 15px;">評分</div>
                <el-rate :value="Number(ProjectInfo.star)" disabled show-score text-color="#3E4F7A"
                    :colors="['#3E4F7A', '#3E4F7A', '#3E4F7A']">
                </el-rate>
            </div>
        </div>

        <!-- 垂直排列的商品圖 -->
        <div style="padding: 0 20px;">
            <div v-for="(img, index) in JSON.parse(ProjectInfo.images)" :key="index" style="margin-bottom: 12px;">
                <img :src="`/api/file/download/${img}`"
                    style="width:100%; border: 1px solid #eee; border-radius: 12px;">
            </div>
        </div>

        <!-- 商品介紹 -->
        <div style="padding: 0 20px;">
            <div style="background: #F9FAFC; border-radius: 12px; padding: 18px; margin-bottom: 20px;">
                <div style="color: #3E4F7A; font-weight: 600; margin-bottom: 15px;">商品介紹</div>
                <div style="color: #666; line-height: 1.8; font-size: 15px;">
                    {{ ProjectInfo.introduction }}
                </div>
            </div>
        </div>


        <div style="padding: 0 20px;" v-if="ProjectInfo.auto == 0">
            <el-alert title="該項目支持自動化部署" type="success" :closable="false"
                description="恭喜！該項目支持自動化部署，在您購買該產品後，您將立馬收到我們為您準備好的項目資料，即刻開始使用！" show-icon>
            </el-alert>
        </div>

        <div style="padding: 0 20px;" v-if="ProjectInfo.auto == 1">
            <el-alert title="該項目需要手動部署" type="warning" :closable="false" description="您購買該項目後，需要聯繫我們技術進行專業技術服務。"
                show-icon>
            </el-alert>
        </div>

        <!-- 操作按鈕 -->
        <div style="text-align: center; margin: 30px 20px;">
            <div @click="buy()"
                style="width: 100%; border-radius: 200px; font-size: 16px; background-color: #3E4F7A; padding: 20px 0; color: white;">
                立即購買 · HKD {{ Number(ProjectInfo.price / 100).toFixed(2) }}
            </div>
        </div>

        <div style="padding: 0 20px;">
            <div style="color: #3E4F7A; font-size: 20px; font-weight: 800; margin-bottom: 8px;">
                看看他們說什麼
            </div>

            <div style="margin-bottom: 50px;">
                <div v-if="stars.length <= 0">
                    <el-empty description="暫無記錄"></el-empty>
                </div>
                <div v-else v-for="(item, index) in stars" :key="index"
                    style="background: #F9FAFC; border-radius: 8px; padding: 12px; margin-top: 12px; display: flex; align-items: center;">
                    <div>
                        <img :src="'/api/file/download/' + item.user.img" alt="" srcset=""
                            style="width: 40px; height: auto; display: flex;">
                    </div>
                    <div style="flex: 2; margin-left: 12px;">
                        <div style="display: flex; justify-content: space-between;">
                            <div style="display: flex;">
                                <div style="color: #3E4F7A; font-weight: 800; font-size: 14px;">{{ item.user.nick }}
                                </div>
                                <div
                                    style="padding: 2px 4px; background: #E8F5ED; border-radius: 4px; color: #43974E; font-size: 12px; margin-left: 4px;">
                                    {{ vipData.name[item.vip] }}</div>
                            </div>
                            <div> <el-rate :value="Number(item.star.star)" :max="Number(item.star.star)" disabled
                                    text-color="#3E4F7A" :colors="['#3E4F7A', '#3E4F7A', '#3E4F7A']">
                                </el-rate></div>
                        </div>
                        <div style="color: #666; font-size: 14px; margin: 8px 0;">
                            {{ item.star.comments }}
                        </div>
                        <div style="color: #666; font-size: 15px; text-align: right; font-size: 12px; color: grey;">
                            {{ formatTimestamp(item.star.create_at) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: 'ShopInfo',
    data() {
        return {
            ProjectId: "",
            ProjectInfo: {},
            stars: [],
            vipMembers: [],
            vipData: []
        }
    },

    mounted() {
        // 賦值商品ID
        this.ProjectId = this.$route.query.id

        // 獲取商品信息
        this.GetProjectInfo()

        // 獲取會員列表
        this.getVipMember()

    },

    methods: {
        getVipMember() {
            this.$axios.get(`/api/vip_member/list`).then(res => {
                var d = res.data.data
                this.vipMembers = d


                // 獲取會員
                this.getVipData()
            })
        },
        getVipData() {
            this.$axios.get("/api/vip_member/arr").then(r => {
                // console.log(r.data.data)
                this.vipData = r.data.data

                // 获取评论
                this.getStars()
            })
        },
        getStars() {
            this.$axios.get(`/api/star/list?id=${this.ProjectId}`).then(res => {
                var d = res.data.data.items


                for (var i = 0; i < d.length; i++) {
                    // console.log(d[i].user.accumulate)
                    var vip = this.vipData.res
                    var amount = d[i].user.accumulate

                    // console.log(amount)
                    // console.log(vip)

                    // 檢測現在的會員
                    for (var j = 0; j < vip.length; j++) {
                        // console.log(j)
                        console.log(amount)
                        console.log(vip[j])

                        if (amount >= vip[j]) {
                            d[i].vip = j
                        } else {
                            break
                        }
                    }

                }


                this.stars = d
            })
        },
        formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss', isSeconds = true) {
            // 處理秒級時間戳
            const ts = isSeconds ? timestamp * 1000 : timestamp;
            const date = new Date(ts);

            // 時間元素提取
            const year = date.getFullYear();
            const month = date.getMonth() + 1; // 月份從0開始計算
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            // 補零函數
            const pad = n => n.toString().padStart(2, '0');

            // 格式替換
            return format
                .replace(/YYYY/g, year)
                .replace(/MM/g, pad(month))
                .replace(/DD/g, pad(day))
                .replace(/HH/g, pad(hours))
                .replace(/mm/g, pad(minutes))
                .replace(/ss/g, pad(seconds));
        },
        buy() {
            this.$confirm('您確認要購買該商品嗎?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post("/api/order/add", {
                    project_id: this.ProjectId
                }).then((res) => {
                    if (res.data.status === 0) {
                        this.$confirm('我們將為您跳轉到[我的]頁面', '購買成功', {
                            confirmButtonText: '好的',
                            type: 'warning',
                            showCancelButton: false
                        }).then(() => {
                            localStorage.setItem("selTopMenuIndex", 'my')
                            this.$router.push({ name: 'Home' })
                        }).catch(() => {

                        });
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }).catch(() => {

            });


        },
        GetProjectInfo() {
            this.$axios.get(`/api/project/info?id=${this.ProjectId}`).then(res => {
                this.ProjectInfo = res.data.data
            })
        },
        close() {
            this.$router.go(-1);
        },
    }
}
</script>

<style>
.dialogBox {
    border-radius: 10px !important;
}
</style>
